// Small config module for gating checkout. Replaces the old paddle-env.ts
// (deleted as part of the Paddle → Stripe migration).
const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;
const checkoutEnabledFlag = import.meta.env.VITE_CHECKOUT_ENABLED as string | undefined;

/**
 * Checkout is gated on the payment client token — the only signal that
 * reliably survives the production build (VITE_CHECKOUT_ENABLED was not
 * inlined in the deployed bundle, which kept live checkout closed even
 * after go-live).
 *
 * - pk_test_ → preview/sandbox: open, so every scenario is testable.
 * - pk_live_ → go-live complete: open.
 * - no token → misconfigured build: closed (show the waitlist notice
 *   instead of a broken checkout).
 * - VITE_CHECKOUT_ENABLED="false" → explicit kill switch, always closed.
 */
export function isCheckoutEnabled(): boolean {
  if (checkoutEnabledFlag === "false") return false;
  if (clientToken?.startsWith("pk_test_")) return true;
  if (clientToken?.startsWith("pk_live_")) return true;
  return false;
}


export const WAITLIST_MAILTO =
  "mailto:hello@tack.company?subject=Tack%20waitlist&body=Hi%20Tack%20team%2C%20please%20add%20me%20to%20the%20waitlist.";
